import { render, staticRenderFns } from "./sr_jxc_report.vue?vue&type=template&id=5b4db223&scoped=true"
import script from "./sr_jxc_report.vue?vue&type=script&lang=js"
export * from "./sr_jxc_report.vue?vue&type=script&lang=js"
import style0 from "./sr_jxc_report.vue?vue&type=style&index=0&id=5b4db223&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4db223",
  null
  
)

export default component.exports